export default __webpack_public_path__ + "static/media/star.1b30ef23.svg";